// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__ZiSlr","actions":"style_actions__oWDz-","actions_btn":"style_actions_btn__O0cVn"};